export const faqContent = {
  ar: {
    eyebrow: "قبل أن نبدأ",
    title: "ما تحتاج معرفته قبل المراسلة",
    sub: "وضوح في البداية يساعدك على اتخاذ القرار المناسب لعملك.",
    items: [
      {
        question: "لا أعرف إن كنت أحتاج موقعًا أو نظامًا. هل أراسلك؟",
        answer:
          "نعم. أخبرني كيف يسير العمل اليوم وأين تواجه الصعوبة. نحدّد هل تحتاج إلى موقع يشرح عرضك، أو نظام ينظّم العمل ويربط أدواتك، أو محتوى وفيديوهات لمنتجك. لا تحتاج إلى معرفة اسم الحل قبل التواصل.",
      },
      {
        question: "كم سيكلّف المشروع؟",
        answer: "تختلف التكلفة حسب ما سنبنيه، وعدد الصفحات أو الخطوات، والتكامل مع أدواتك. بعد فهم احتياجك نحدّد نطاقًا وتكلفة واضحة قبل بدء التنفيذ. أرسل ما تريد تحسينه لنبدأ التقدير.",
      },
      {
        question: "كم يستغرق التنفيذ؟",
        answer: "تتحدّد المدة بحسب حجم العمل، وجاهزية المحتوى والبيانات، وما يحتاج إلى ربط أو مراجعة. نتفق على جدول قبل البدء، ويمكن تقسيم المشروع إلى مراحل تبدأ بالأولوية الأهم.",
      },
      {
        question: "كيف تبدأ عملية العمل؟",
        answer:
          "نبدأ برسالة قصيرة توضّح الفكرة أو المشكلة. بعدها أحدد معك الهدف والنطاق والخطوة الأولى المناسبة، ثم تحصل على مسار عمل واضح قبل بدء التنفيذ.",
      },
      {
        question: "هل يمكن بناء تجربة عربية كاملة؟",
        answer:
          "نعم. الموقع نفسه مبني بالعربية أولاً ويدعم اتجاه RTL فعليًا، مع إمكانية تصميم التجربة بالإنجليزية أو الفرنسية عند الحاجة.",
      },
      {
        question: "هل تستخدم الذكاء الاصطناعي في كل مشروع؟",
        answer:
          "فقط عندما يضيف قيمة حقيقية. قد يكون الحل أتمتة بسيطة، واجهة أوضح، أو نظامًا ذكيًا كاملًا. المهم هو تقليل التعقيد وتحسين النتيجة.",
      },
    ],
  },
  en: {
    eyebrow: "Before we start",
    title: "Before you get in touch",
    sub: "Clear expectations help you make the right decision for your business.",
    items: [
      {
        question: "I'm not sure which service I need. Can I still contact you?",
        answer:
          "Yes. Tell me how things work today and where you get stuck. We'll work out whether you need a website, a management system that connects your tools, or videos and content for your product. You don't need to know the name of the solution first.",
      },
      {
        question: "How much will the project cost?",
        answer: "Cost depends on what we build, the number of pages or workflow steps, and integrations with your tools. Once I understand the need, we agree on a clear scope and cost before work begins.",
      },
      {
        question: "How long will it take?",
        answer: "Timing depends on scope, the readiness of content and data, and the integrations and reviews needed. We agree on a schedule before starting and can break the project into phases, beginning with your top priority.",
      },
      {
        question: "How does a project begin?",
        answer:
          "It starts with a short message about the idea or problem. We clarify the goal, scope, and best first step, then agree on a practical path before production begins.",
      },
      {
        question: "Can you build a complete Arabic experience?",
        answer:
          "Yes. This site itself is Arabic-first with real RTL behavior, and the experience can also be designed in English or French when needed.",
      },
      {
        question: "Do you use AI in every project?",
        answer:
          "Only when it adds real value. The right answer might be a simple automation, a clearer interface, or a complete intelligent system. The goal is always less complexity and a better outcome.",
      },
    ],
  },
  fr: {
    eyebrow: "Avant de commencer",
    title: "Avant de me contacter",
    sub: "Des attentes claires pour prendre la bonne décision pour votre activité.",
    items: [
      {
        question: "Je ne sais pas quel service choisir. Puis-je vous contacter ?",
        answer:
          "Oui. Décrivez votre fonctionnement actuel et ce qui vous bloque. Nous verrons si vous avez besoin d'un site, d'un système de gestion qui connecte vos outils, ou de vidéos et de contenu produit. Pas besoin de connaître la solution à l'avance.",
      },
      {
        question: "Combien coûtera le projet ?",
        answer: "Le coût dépend du périmètre, du nombre de pages ou d'étapes et des connexions à vos outils. Après avoir compris le besoin, nous convenons d'un périmètre et d'un coût clairs avant de commencer.",
      },
      {
        question: "Quel est le délai de réalisation ?",
        answer: "Le délai dépend du volume de travail, des contenus et données disponibles, des intégrations et des validations. Nous fixons un calendrier avant de commencer et pouvons avancer par phases, en donnant la priorité au besoin principal.",
      },
      {
        question: "Comment démarre un projet ?",
        answer:
          "Tout commence par un court message sur l’idée ou le problème. Nous clarifions l’objectif, le périmètre et la meilleure première étape avant de définir un parcours de production concret.",
      },
      {
        question: "Pouvez-vous créer une expérience arabe complète ?",
        answer:
          "Oui. Ce site est lui-même conçu d’abord en arabe avec un véritable comportement RTL, et l’expérience peut aussi être créée en anglais ou en français.",
      },
      {
        question: "Utilisez-vous l’IA dans chaque projet ?",
        answer:
          "Uniquement lorsqu’elle apporte une vraie valeur. La bonne réponse peut être une automatisation simple, une interface plus claire ou un système intelligent complet.",
      },
    ],
  },
};
